import type { TransformMetadataResult } from '@post-office/message-template-contracts/message-template-metadata';

import { Stages } from '..';
import { type TransformMetadataBackendPlacementStage } from './types';
import type {
	AnyBackendPlacementStageData,
	AnyBackendPlacementStageInput,
} from '../../../../create-placement/types';

export const applyTransformMetadata =
	(transformMetadata?: TransformMetadataBackendPlacementStage) =>
	async (params: AnyBackendPlacementStageInput): Promise<AnyBackendPlacementStageData> => {
		const transformedMetadata = await Stages.maybe(transformMetadata)(params);
		const placementId = params?.request?.orchestrationContext?.placementId ?? 'no-placement-found';

		return Stages.mergeMetadata<TransformMetadataResult>((original, metadata) => ({
			...original,
			enrichedAttributes: {
				'in-app': {
					[placementId]: metadata,
				},
			},
		}))(params, transformedMetadata);
	};
